/**
* 招聘 模块 - 职位描述 - 组件
*/
<template>
  <div class="h-recruit">
    <div class="h-banner">
      <img src="@/assets/img/recruit.jpg" />
    </div>
    <article class="h-article">
      <h4 class="h-title">{{tableData.position}}</h4>
      <div class="h-info">
        <span>人数：{{tableData.number}}人</span>
        <span>性别：{{tableData.sex}}</span>
        <span>学历：{{tableData.education}}</span>
        <span>工作经验：{{tableData.experience}}</span>
        <p>待遇：{{tableData.treatment}}</p>
      </div>
      <dl>
        <dt>岗位职责：</dt>
        <dd v-html="tableData.duty"></dd>
        <!-- <dd>2、顾客疑问解答，做好售前、售中、售后服务工作，促成产品销售；</dd>
        <dd>3、参与店面日常工作，维护店面及公司品牌形象。</dd> -->
      </dl>
      <dl>
        <dt>任职要求：</dt>
        <dd v-html="tableData.require"></dd>
        <!-- <dd>2、高中以上学历，1—2年服务行业工作经验，有珠宝行业经验者优先考虑；</dd>
        <dd>3、为人热情、耐心、诚实守信，善于与人沟通；</dd>
        <dd>4、具备较强的服务意识、服从意识和团队合作精神。工作时间：半天制 </dd> -->
      </dl>
      <dl>
        <dt>工作时间：</dt>
        <dd v-html="tableData.timerole"></dd>
      </dl>
      <dl>
        <dt>工作地址：</dt>
        <dd v-html="tableData.address"></dd>
      </dl>
      <dl>
        <dt>联系电话：</dt>
        <dd v-html="tableData.tel"></dd>
      </dl>
    </article>
  </div>
</template>
<script>
//import { recruitList } from '@/mock' // 招聘数据
import { recruitDetailData } from '@/api'

export default {
  name: 'JobDesc',
  props: {},
  data () {
    return {
      id:this.$route.params.id,

      tableData: {},
    }
  },
  created () {
     this.getRecruitData() // 招聘数据加载
  },
  mounted () {
    // this.getRecruitData() // 招聘数据加载
   // this.tableData = recruitList.result // 使用接口时 此处删除
  },
  methods: {
    textareaTo(str) {
        return str.replace(/\\n/gm,"<br/>");
    },
    getRecruitData () {
      const params = { // 请求参数 --- 根据情况 是否需要
        id: this.id
      }
      recruitDetailData(params).then(res => {
        this.tableData = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .h-recruit {
  }
  .h-banner{
    img{
      width: 100%;
      height: 400px;
    }
  }
  .h-title{
    padding: 10px 15px;
    margin: 10px 0;
    font-weight: normal;
    border-bottom: 1px dashed #dcdcdc;
    &:before{
      position: absolute;
      content: '';
      width: 6px;
      height: 6px;
      margin: 5px 0 0 -15px;
      border-radius: 100%;
      border: 2px solid #8d0027;
    }
  }
  .h-info{
    span{
      margin-right: 20px;
    }
    p{
      margin: 10px 0;
    }
  }
  .h-article{
    dl{
      margin-top: 10px;
      line-height: 25px;
    }
    dt{
      font-weight: 900;
      color: #666;
    }
    dd{
      padding-left: 10px;
      font-size: 12px;
    }
  }
</style>
